var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBgShadowMobileBottom({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 295,
    height: 195,
    viewBox: "0 0 295 195",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.17202e-06 76.5891L6.55671e-07 179.911C2.93554e-07 188.195 6.71573 194.911 15 194.911L294.873 194.911C294.957 192.436 295 189.948 295 187.448C295 83.9237 221.886 0.000408791 131.696 0.000404849C77.6425 0.000402486 29.7224 30.1457 5.17202e-06 76.5891Z",
    fill: "#0008C3",
    fillOpacity: 0.05
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgShadowMobileBottom);
export default __webpack_public_path__ + "static/media/bg-shadow-mobile-bottom.17ccc828c72a07485cf09f7730c98579.svg";
export { ForwardRef as ReactComponent };